module.exports = __webpack_public_path__ + "img/97.01a29659.jpg";